import Loadable from 'react-loadable';
import { Preloader } from '../../components/Loading';

export default Loadable({
  loader: () => import('./index'),
  loading: Preloader,
});



// WEBPACK FOOTER //
// ./src/containers/browser_support/loadable.js